import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest, HttpResponse  } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

// For info see
// https://medium.com/@ryanchenkie_40935/angular-authentication-using-the-http-client-and-http-interceptors-2f9d1540eb8
//

@Injectable({ providedIn: 'root' })
export class AuthInjectorService /*TokenInterceptor */ {

  /**
   * Creates an instance of TokenInterceptor.
   * @param {AuthService} auth
   * @memberof TokenInterceptor
   */
  
  constructor(private auth: AuthService) {}

  /**
   * Intercept all HTTP request to add JWT token to Headers
   * @param {HttpRequest<any>} request
   * @param {HttpHandler} next
   * @returns {Observable<HttpEvent<any>>}
   * @memberof TokenInterceptor
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {    
    // Only add Auth header if user is logged in.    
    // console.log('header intercept:' + request.url);  
    if (this.auth.isUserLoggedIn()) {
      // console.log('using Injector to add Authorizaton Header');
      request = request.clone({
        setHeaders: {
          Authorization: this.auth.getAuthorizationHeaderValue(),
        },
      });
    }
    // return next.handle(request);

    // https://medium.com/@ryanchenkie_40935/angular-authentication-using-the-http-client-and-http-interceptors-2f9d1540eb8
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          console.log('HTTP Request returned 401 - Unauthorized', err);
          this.auth.refreshToken();          
        }
      }
    }));
  }
}
